
import React, { createContext, useContext, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { SidebarProvider } from "@/components/ui/sidebar";
import { AppSidebar } from './AppSidebar';
import { Header } from './Header';
import { DownloadAccessProvider } from '@/components/DownloadGate/DownloadAccessProvider';

export const HelpModalContext = createContext({ open: () => {}, close: () => {}, isOpen: false });

export const MainLayout = () => {
  const [helpOpen, setHelpOpen] = useState(false);
  const helpContextValue = {
    open: () => setHelpOpen(true),
    close: () => setHelpOpen(false),
    isOpen: helpOpen,
  };
  return (
    <HelpModalContext.Provider value={helpContextValue}>
      <SidebarProvider>
        <DownloadAccessProvider>
          <div className="min-h-screen flex w-full bg-background">
            <AppSidebar />
            <div className="flex-1 flex flex-col">
              <Header />
              <main className="flex-1 p-6">
                <Outlet />
              </main>
            </div>
          </div>
          {/* Help modal rendered at root for global access */}
          {helpOpen && (
            <div className="fixed inset-0 z-[10001] flex items-center justify-center bg-black/40 animate-fade-in">
              <div className="bg-white/80 backdrop-blur-lg rounded-2xl shadow-2xl p-8 max-w-lg w-full animate-fade-in-slow border border-blue-200">
                <h2 className="text-2xl font-bold mb-4 text-blue-700">Help & Support</h2>
                <p className="mb-4">Welcome to the GreenCard Help Center! Here you can find documentation, FAQs, and contact support.</p>
                <ul className="list-disc ml-6 mb-4 text-blue-900">
                  <li><a href="/docs" className="underline hover:text-blue-600">Documentation</a></li>
                  <li><a href="/faq" className="underline hover:text-blue-600">Frequently Asked Questions</a></li>
                  <li><a href="mailto:support@greencard.com" className="underline hover:text-blue-600">Contact Support</a></li>
                </ul>
                <button onClick={() => setHelpOpen(false)} className="w-full mt-2 rounded-lg bg-white/60 border border-blue-200 text-blue-700 font-semibold py-2 px-4 shadow hover:bg-blue-50 transition backdrop-blur-md">Close</button>
              </div>
            </div>
          )}
        </DownloadAccessProvider>
      </SidebarProvider>
    </HelpModalContext.Provider>
  );
};
